import React from "react";

const CardTab = ({ tabs }) => {
    return (
        <div className="card card-primary card-outline card-outline-tabs">
            <div className="card-header p-0 border-bottom-0">
                <ul className="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
                    {tabs.map((tab, index) => (
                        <li className="nav-item" key={index}>
                            <a
                                className={`nav-link ${index === 0 ? "active" : ""}`}
                                id={`custom-tabs-${index}-tab`}
                                data-toggle="pill"
                                href={`#custom-tabs-${index}`}
                                role="tab"
                                aria-controls={`custom-tabs-${index}`}
                                aria-selected={index === 0 ? "true" : "false"}
                            >
                                {tab.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="card-body">
                <div className="tab-content" id="custom-tabs-four-tabContent">
                    {tabs.map((tab, index) => (
                        <div
                            key={index}
                            className={`tab-pane fade ${index === 0 ? "active show" : ""}`}
                            id={`custom-tabs-${index}`}
                            role="tabpanel"
                            aria-labelledby={`custom-tabs-${index}-tab`}
                        >
                            {tab.content}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CardTab;
